import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import React, { useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import useValidationRules from '../../hooks/useValidationRules';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMLabel, MyMVariantLabel } from '../../ui-elements/MyMLabel';
import ValidatableTextBox from '../../ui-parts/ValidatableTextBox';

/**
 * UserProfile Detail Component
 */
const UserProfileDetail = React.memo(({ apiRequest, controlSettings, messageList, userInfo, setUserInfo, setIsLoading }) => {
  // 変数・State
  const { handleSubmit, control, formState, reset } = useForm({
    mode: 'onSubmit',
  })
  const validationRules = useValidationRules();

  const [isEditMode, setIsEditMode] = useState(false);
  const { setAuthUser } = useContext(AuthUserContext);

  /** ChangeDetail押下時処理 */
  const onClickChangeDetails = () => {
    setIsEditMode(() => !isEditMode);
  };

  /** Cancelボタン押下時処理 */
  const onClickCancel = () => {
    setIsEditMode(!isEditMode);
    reset();
  }

  /** Updateボタン押下時処理 */
  const onSubmit = (data, e) => {
    if (window.confirm(messageList.MyM_MSG_I_0001)) {

      const callbackSuccess = (result) => {
        setUserInfo({ ...userInfo, FirstName: data.firstName, LastName: data.lastName });
        setIsEditMode(() => !isEditMode);

        const callbackRequestAuthUser = (result) => {
          setAuthUser(result);
          window.alert(messageList.MyM_MSG_I_0002);
          setIsLoading(false);
        };
        // ユーザコンテキスト情報再取得
        apiRequest.requestJson('api/page/auth-user', 'GET', callbackRequestAuthUser, callbackFailed);
      }

      const callbackFailed = () => setIsLoading(false);

      setIsLoading(true);
      apiRequest.requestJson('api/user-info/update-for-profile', 'POST', callbackSuccess, callbackFailed, data);
    }
  };

  const onError = (errors, e) => {
    window.alert(messageList.MyM_MSG_E_0003);
  };

  return (
    <>
      <Grid item xs={12} md={12} lg={3} >
        <Box className='profile-content'>


          <TableContainer>
            <Table sx={{ border: 0, '&:last-child td, &:last-child th': { border: 0 } }}>
              <TableHead>
                <TableRow>
                  <TableCell variant='head' sx={{ padding: '16px 0' }}>
                    <MyMVariantLabel variant='h5'>{controlSettings.LabelList.lblUserDetailTitle}</MyMVariantLabel>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell variant='head' sx={{ padding: "0 16px" }}>
                    <Grid container spacing={1} className="mt-0" sx={{}}>
                      <Grid item xs={12} md={12} lg={12} sx={{ minHeight: "380px", maxHeight: "380px", overflowY: "auto" }}>
                        <TableContainer>
                          <Table sx={{ 'td, th': { border: 0, padding: '8px 0px' } }}>
                            <TableBody>
                              <TableRow>
                                <TableCell component='th'>
                                  <MyMLabel className='fw-bold'>{controlSettings.LabelList.lblNameTitle}</MyMLabel>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                {!isEditMode
                                  ? <TableCell><MyMLabel>{userInfo.FirstName} {userInfo.LastName}</MyMLabel></TableCell>
                                  :
                                  <>
                                    <TableCell className='py-3'>
                                      <ValidatableTextBox
                                        control={control}
                                        name="firstName"
                                        defaultValue={userInfo.FirstName}
                                        formState={formState}
                                        maxLength={50}
                                        color="#fff"
                                        rules={{
                                          ...validationRules.required(),
                                          ...validationRules.maxLength(50),
                                          ...validationRules.alphanumericOnly(),
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell className='py-3'>
                                      <ValidatableTextBox
                                        control={control}
                                        name="lastName"
                                        defaultValue={userInfo.LastName}
                                        formState={formState}
                                        maxLength={50}
                                        color="#fff"
                                        rules={{
                                          ...validationRules.maxLength(50),
                                          ...validationRules.alphanumericOnly(),
                                        }}
                                      />
                                    </TableCell>
                                  </>}
                              </TableRow>
                              <TableRow>
                                <TableCell component='th'>
                                  <MyMLabel className='fw-bold'>{controlSettings.LabelList.lblMailTitle}</MyMLabel>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell colSpan={2}>
                                  <MyMLabel>{userInfo.UserId}</MyMLabel>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell component='th'>
                                  <MyMLabel className='fw-bold'>{controlSettings.LabelList.lblCompanyTitle}</MyMLabel>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell colSpan={2}>
                                  <MyMLabel>{userInfo.CompanyName}</MyMLabel>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </Grid>
                      <Grid item xs={12} md={12} lg={12}>
                        <Stack direction='row' justifyContent="flex-end" spacing={3}>
                          {!isEditMode
                            ? <MyMButton onClick={onClickChangeDetails}>{controlSettings.LabelList.btnChangeDetail}</MyMButton>
                            :
                            <>
                              <MyMButton onClick={handleSubmit(onSubmit, onError)}>{controlSettings.LabelList.btnUpdate}</MyMButton>
                              <MyMButton onClick={onClickCancel}>{controlSettings.LabelList.btnCancel}</MyMButton>
                            </>
                          }
                        </Stack>
                      </Grid>
                    </Grid>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

      </Grid>
    </>
  );
})
export default UserProfileDetail;
